export default __webpack_public_path__ + "static/media/FoundersGrotesk-MediumItalic.0a17806b.woff2";